/**
 * @flow
 * @relayHash 42082211413f9dd89ebf259621a7ebba
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserInventory_data$ref = any;
export type UserInventoryQueryVariables = {|
  userId: string
|};
export type UserInventoryQueryResponse = {|
  +adminManagement: ?{|
    +user: ?{|
      +$fragmentRefs: UserInventory_data$ref
    |}
  |}
|};
export type UserInventoryQuery = {|
  variables: UserInventoryQueryVariables,
  response: UserInventoryQueryResponse,
|};
*/

/*
query UserInventoryQuery(
  $userId: String!
) {
  adminManagement {
    user(userId: $userId) {
      ...UserInventory_data
      id
    }
    id
  }
}

fragment UserInventory_data on AdminManagementUser {
  inventory(orderBy: "", orderDirection: DESC, first: 100, skip: 0, statuses: []) {
    count
    edges {
      node {
        id
        cuid
        status
        createdAt
        disposedAt
        type
        caseBox {
          title
          slug
          price
          id
        }
        product {
          title
          slug
          price
          image {
            x1 {
              default
              id
            }
            id
          }
          id
        }
        meta
        cart {
          cuid
          status
        }
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
    var v0 = [
            {
                kind: 'LocalArgument',
                name: 'userId',
                type: 'String!',
                defaultValue: null,
            },
        ],
        v1 = [
            {
                kind: 'Variable',
                name: 'userId',
                variableName: 'userId',
            },
        ],
        v2 = {
            kind: 'ScalarField',
            alias: null,
            name: 'id',
            args: null,
            storageKey: null,
        },
        v3 = {
            kind: 'ScalarField',
            alias: null,
            name: 'cuid',
            args: null,
            storageKey: null,
        },
        v4 = {
            kind: 'ScalarField',
            alias: null,
            name: 'status',
            args: null,
            storageKey: null,
        },
        v5 = {
            kind: 'ScalarField',
            alias: null,
            name: 'title',
            args: null,
            storageKey: null,
        },
        v6 = {
            kind: 'ScalarField',
            alias: null,
            name: 'slug',
            args: null,
            storageKey: null,
        },
        v7 = {
            kind: 'ScalarField',
            alias: null,
            name: 'price',
            args: null,
            storageKey: null,
        }
    return {
        kind: 'Request',
        fragment: {
            kind: 'Fragment',
            name: 'UserInventoryQuery',
            type: 'Query',
            metadata: null,
            argumentDefinitions: (v0 /*: any*/),
            selections: [
                {
                    kind: 'LinkedField',
                    alias: null,
                    name: 'adminManagement',
                    storageKey: null,
                    args: null,
                    concreteType: 'AdminManagement',
                    plural: false,
                    selections: [
                        {
                            kind: 'LinkedField',
                            alias: null,
                            name: 'user',
                            storageKey: null,
                            args: (v1 /*: any*/),
                            concreteType: 'AdminManagementUser',
                            plural: false,
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: 'UserInventory_data',
                                    args: null,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        operation: {
            kind: 'Operation',
            name: 'UserInventoryQuery',
            argumentDefinitions: (v0 /*: any*/),
            selections: [
                {
                    kind: 'LinkedField',
                    alias: null,
                    name: 'adminManagement',
                    storageKey: null,
                    args: null,
                    concreteType: 'AdminManagement',
                    plural: false,
                    selections: [
                        {
                            kind: 'LinkedField',
                            alias: null,
                            name: 'user',
                            storageKey: null,
                            args: (v1 /*: any*/),
                            concreteType: 'AdminManagementUser',
                            plural: false,
                            selections: [
                                {
                                    kind: 'LinkedField',
                                    alias: null,
                                    name: 'inventory',
                                    storageKey:
                                        'inventory(first:100,orderBy:"",orderDirection:"DESC",skip:0,statuses:[])',
                                    args: [
                                        {
                                            kind: 'Literal',
                                            name: 'first',
                                            value: 100,
                                        },
                                        {
                                            kind: 'Literal',
                                            name: 'orderBy',
                                            value: '',
                                        },
                                        {
                                            kind: 'Literal',
                                            name: 'orderDirection',
                                            value: 'DESC',
                                        },
                                        {
                                            kind: 'Literal',
                                            name: 'skip',
                                            value: 0,
                                        },
                                        {
                                            kind: 'Literal',
                                            name: 'statuses',
                                            value: [],
                                        },
                                    ],
                                    concreteType:
                                        'AdminManagementInventoryConnection',
                                    plural: false,
                                    selections: [
                                        {
                                            kind: 'ScalarField',
                                            alias: null,
                                            name: 'count',
                                            args: null,
                                            storageKey: null,
                                        },
                                        {
                                            kind: 'LinkedField',
                                            alias: null,
                                            name: 'edges',
                                            storageKey: null,
                                            args: null,
                                            concreteType:
                                                'AdminManagementInventoryEdge',
                                            plural: true,
                                            selections: [
                                                {
                                                    kind: 'LinkedField',
                                                    alias: null,
                                                    name: 'node',
                                                    storageKey: null,
                                                    args: null,
                                                    concreteType:
                                                        'AdminManagementInventory',
                                                    plural: false,
                                                    selections: [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        (v4 /*: any*/),
                                                        {
                                                            kind: 'ScalarField',
                                                            alias: null,
                                                            name: 'createdAt',
                                                            args: null,
                                                            storageKey: null,
                                                        },
                                                        {
                                                            kind: 'ScalarField',
                                                            alias: null,
                                                            name: 'disposedAt',
                                                            args: null,
                                                            storageKey: null,
                                                        },
                                                        {
                                                            kind: 'ScalarField',
                                                            alias: null,
                                                            name: 'type',
                                                            args: null,
                                                            storageKey: null,
                                                        },
                                                        {
                                                            kind: 'LinkedField',
                                                            alias: null,
                                                            name: 'caseBox',
                                                            storageKey: null,
                                                            args: null,
                                                            concreteType:
                                                                'AdminManagementInventoryCaseBox',
                                                            plural: false,
                                                            selections: [
                                                                (v5 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v2 /*: any*/),
                                                            ],
                                                        },
                                                        {
                                                            kind: 'LinkedField',
                                                            alias: null,
                                                            name: 'product',
                                                            storageKey: null,
                                                            args: null,
                                                            concreteType:
                                                                'AdminManagementInventoryProduct',
                                                            plural: false,
                                                            selections: [
                                                                (v5 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    kind:
                                                                        'LinkedField',
                                                                    alias: null,
                                                                    name:
                                                                        'image',
                                                                    storageKey: null,
                                                                    args: null,
                                                                    concreteType:
                                                                        'AdminManagementImage',
                                                                    plural: false,
                                                                    selections: [
                                                                        {
                                                                            kind:
                                                                                'LinkedField',
                                                                            alias: null,
                                                                            name:
                                                                                'x1',
                                                                            storageKey: null,
                                                                            args: null,
                                                                            concreteType:
                                                                                'AdminManagementImageUrl',
                                                                            plural: false,
                                                                            selections: [
                                                                                {
                                                                                    kind:
                                                                                        'ScalarField',
                                                                                    alias: null,
                                                                                    name:
                                                                                        'default',
                                                                                    args: null,
                                                                                    storageKey: null,
                                                                                },
                                                                                (v2 /*: any*/),
                                                                            ],
                                                                        },
                                                                        (v2 /*: any*/),
                                                                    ],
                                                                },
                                                                (v2 /*: any*/),
                                                            ],
                                                        },
                                                        {
                                                            kind: 'ScalarField',
                                                            alias: null,
                                                            name: 'meta',
                                                            args: null,
                                                            storageKey: null,
                                                        },
                                                        {
                                                            kind: 'LinkedField',
                                                            alias: null,
                                                            name: 'cart',
                                                            storageKey: null,
                                                            args: null,
                                                            concreteType:
                                                                'AdminManagementInventoryCart',
                                                            plural: false,
                                                            selections: [
                                                                (v3 /*: any*/),
                                                                (v4 /*: any*/),
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                                (v2 /*: any*/),
                            ],
                        },
                        (v2 /*: any*/),
                    ],
                },
            ],
        },
        params: {
            operationKind: 'query',
            name: 'UserInventoryQuery',
            id: null,
            text:
                'query UserInventoryQuery(\n  $userId: String!\n) {\n  adminManagement {\n    user(userId: $userId) {\n      ...UserInventory_data\n      id\n    }\n    id\n  }\n}\n\nfragment UserInventory_data on AdminManagementUser {\n  inventory(orderBy: "", orderDirection: DESC, first: 100, skip: 0, statuses: []) {\n    count\n    edges {\n      node {\n        id\n        cuid\n        status\n        createdAt\n        disposedAt\n        type\n        caseBox {\n          title\n          slug\n          price\n          id\n        }\n        product {\n          title\n          slug\n          price\n          image {\n            x1 {\n              default\n              id\n            }\n            id\n          }\n          id\n        }\n        meta\n        cart {\n          cuid\n          status\n        }\n      }\n    }\n  }\n}\n',
            metadata: {},
        },
    }
})()
// prettier-ignore
;(node/*: any*/).hash = 'bcdc071fd1a9dfd1b2f9f9a5d5b38bc3';
module.exports = node
